<template>
    <div>
        <v-server-table ref="equipmentTable" url="/equipment/tracking/list" :columns="columns" :options="options">
            <template slot="employee_last_name" slot-scope="props">
                <template v-if="props.row.employee_last_name">{{ props.row.employee_first_name + ' ' + props.row.employee_last_name }}</template>
            </template>

            <template slot="creatorLastName" slot-scope="props">
                <template v-if="props.row.creatorLastName">{{ props.row.creatorFirstName + ' ' + props.row.creatorLastName }}</template>
            </template>

            <template slot="tracking_status" slot-scope="props">
                <span class="badge" :class="status_color(props.row)">{{ props.row.tracking_status }}</span>
            </template>

            <template slot="JobsiteName" slot-scope="props">
                <router-link :to="`/jobsites/view/${props.row.jobsite_id}`" v-if="props.row.jobsite_id">
                    {{ props.row.JobsiteNumber }} - {{ props.row.JobsiteName }}
                </router-link>
            </template>

            <template slot="DivisionName" slot-scope="props">
                <template v-if="props.row.division_id">
                    {{ props.row.division_code }} - {{ props.row.DivisionName }}
                </template>
            </template>

            <template slot="tracking_date" slot-scope="props">
                {{ props.row.tracking_date | moment("MM/DD/YYYY hh:mm a") }}
            </template>

            <template slot="file_id" slot-scope="props">
                <span v-if="props.row.file_id">
                    <span v-if="!props.row.download_only">
                        <a :href="`/files/view/${props.row.file_id}`" target="_blank" title="View Uploaded Inspection">View</a>&nbsp;|
                    </span>
                    <a :href="`/files/download/${props.row.file_id}`" target="_blank" title="Download Uploaded Inspection">{{ props.row.file_name }}</a>
                </span>
                <span v-if="props.row.inspection_id">
                    <router-link :to="`/inspections/view/${props.row.inspection_id}`" title="View MeritEHS Inspection">{{ props.row.inspection_id }} - {{ props.row.InspectionDate | moment("MM/DD/YYYY") }}</router-link>
                </span>
            </template>

        </v-server-table>
    </div>
</template>

<script>
    export default {
        props: ['equipment_id'],

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                columns: [
                    // 'equipment_tracking_id',
                    'employee_last_name',
                    'creatorLastName',
                    'tracking_status',
                    'JobsiteName',
                    'DivisionName',
                    'notes',
                    'tracking_date',
                    'file_id',
                ],
                options: {
                    headings: {
                        employee_last_name: 'Assignee',
                        creatorLastName: 'Creator',
                        JobsiteName: 'Jobsite',
                        DivisionName: 'Division',
                        tracking_status: 'Status',
                        notes: 'Notes',
                        tracking_date: 'Date',
                        file_id: 'Inspection',
                    },
                    orderBy: {
                        ascending: false,
                        column: 'tracking_date',
                    },
                    requestAdapter: (data) => {
                        //INclude the asset
                        data.equipment_id = this.equipment_id;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'equipment_tracking_id',
                },
            }
        },

        methods: {
            status_color(row) {
                let color = '';

                switch (row.tracking_status)
                {
                    case 'Checked In':
                        color = 'badge-success';
                        break;
                    case 'Issued':
                        color = 'badge-warning';
                        break;
                    case 'On Hold':
                        color = 'badge-danger';
                        break;
                    case 'Archived':
                        color = 'badge-dark';
                        break;
                }

                return color;
            },
        },
    }
</script>
